/**
 * 임시 조치: QZ Tray 인증서와 개인키는 GitHub Secrets에서 빌드 시 주입한다.
 *
 * 프론트엔드 번들에 주입되므로 개인키 노출 자체를 막지는 못한다.
 * 후속 작업에서 서명을 백엔드 엔드포인트로 옮기고 개인키 주입을 제거해야 한다.
 */
export const normalizePem = (value: string | undefined): string => (value ?? '').replace(/\\n/g, '\n')

export const QZ_TRAY_CERT = normalizePem(process.env.REACT_APP_QZ_PEM)
export const QZ_TRAY_PRIVATE_KEY = normalizePem(process.env.REACT_APP_QZ_PRV)
